import React from 'react';
import { useState, useEffect } from 'react';
import './phone.scss';
import InputComponent from '../InputComponent';

import countryDialCodes from '../../utils/countryDialCodes.json';

export default function PhoneNumberInput({ value, setValue, setIsChangeInData }) {
  const [dialCodeList, setDialCodeList] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({});
  const [selectedCountryCode, setSelectedCountryCode] = useState({
    ...value,
  });

  useEffect(() => {
    setSelectedCountry({ ...value });
  }, [value]);

  useEffect(() => {
    setValue({
      name: selectedCountryCode.name,
      code: selectedCountryCode.code,
      phone: value.phone,
    });
  }, [selectedCountryCode]);

  useEffect(() => {
    let countryDetails = countryDialCodes.map((country) => {
      return {
        shortName: country.shortName,
        code: country.code,
        name: country.name,
        emoji: country.emoji,
      };
    });
    setDialCodeList(countryDetails);
  }, []);
  return (
    // <div className="phone-container">
    //   <div className="country-select">
    //     <select
    //       onChange={(e) => {
    //         // console.log(e.target.value);
    //       }}
    //     >
    //       {dialCodeList.map((dialCode) => {
    //         return (
    //           <option value={dialCode} key={dialCode.shortName}>
    //             {dialCode.code}
    //           </option>
    //         );
    //       })}
    //     </select>
    //   </div>
    //   <div className="input-container" style={{ width: '100%' }}>
    //     <InputComponent
    //       inputStyle="setup-input"
    //       type="text"
    //       placeholder={'123 456 7890'}
    //       // value={value.phone}
    //       value={value.phone ? value.phone : ''}
    //       onChange={(e) => {
    //         setValue({ ...value, phone: e.target.value });
    //       }}
    //     ></InputComponent>
    //   </div>
    // </div>
    <div className="phone-number-ip">
      <div
        className="country-select"
        onClick={() => {
          setIsExpanded(!isExpanded);
        }}
      >
        <div
          className="selected-country"
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
        >
          <div className="selected-country-details">{`${selectedCountry.code}`}</div>
          <div className="expand-btn" onClick={() => setIsExpanded(!isExpanded)}>
            <img
              src={
                isExpanded
                  ? 'https://holofy-widget-assets.s3.eu-west-2.amazonaws.com/up-caret.png'
                  : 'https://holofy-widget-assets.s3.eu-west-2.amazonaws.com/down-caret.png'
              }
              alt=""
              onClick={() => setIsExpanded(!isExpanded)}
            />
          </div>
        </div>

        {isExpanded && (
          <div className="country-collection">
            <ul className="list-container">
              {dialCodeList.map((country, idx) => (
                <li
                  key={idx}
                  onClick={(e) => {
                    if (setIsChangeInData) setIsChangeInData(true);
                    e.stopPropagation();
                    e.preventDefault();
                    setSelectedCountryCode({
                      emoji: country.emoji,
                      code: country.code,
                      shortName: country.shortName,
                      name: country.name,
                    });
                    setSelectedCountry({
                      emoji: country.emoji,
                      code: country.code,
                      shortName: country.shortName,
                      name: country.name,
                    });
                    setIsExpanded(false);
                  }}
                >
                  <span className="country-code">{country.name + ' ' + country.code}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <div className="input-container">
        <InputComponent
          inputStyle="setup-input"
          type="number"
          placeholder={'123 456 7890'}
          value={value.phone ? value.phone : ''}
          onChange={(e) => {
            if (setIsChangeInData) setIsChangeInData(true);
            setValue({ ...value, phone: e.target.value });
          }}
        ></InputComponent>
      </div>
    </div>
  );
}
